/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getIn } from 'formik';
import type { AnyAction, Dispatch } from 'redux';
import styled from 'styled-components';

import { mapPageFields } from '../../shared/cardConfig/helpers';
import { withStore } from '../../store';
import { contactDeliveryType } from '../../utils/addressHelpers';
import { ErrorIcon, ErrorValidation } from '../ErrorValidation';
import SelectDropDown from '../Select';

const Container = styled.div`
  width: 100%;
`;

const SelectContainer = styled.div`
  margin-bottom: 16px;
`;


interface FieldSelectWithChildrenProps {
  parent?: string;
  name: string;
  options: Array<{
    value: string;
    shouldShowChildren?: boolean;
  }>;
  label?: string;
  selectChildren?: any;
  dispatch: Dispatch<AnyAction>;
  formik: any;
  onChange?: (
    value: string,
    dispatch: Dispatch<AnyAction>,
    formik: any,
    store: any
  ) => Promise<void> | void;
  store: any;
  apiService: any;
  initialSelectState: (store: any) => string;
  required?: boolean;
  isReview?: boolean;
  showSubFieldError?: boolean;
  validateContactCardSubFileds?: boolean;
  isNewContact?: boolean;
}

const Component = ({
  parent,
  name,
  options,
  label,
  selectChildren,
  dispatch,
  formik,
  onChange,
  store,
  apiService,
  initialSelectState,
  required,
  isReview,
  showSubFieldError,
  validateContactCardSubFileds,
  isNewContact,
  ...otherProps
}: FieldSelectWithChildrenProps): JSX.Element => {
  const [selectedOption, setSelectedOption] = useState(
    initialSelectState(store)
  );

  const isReviewPage =
    typeof isReview === 'boolean'
      ? isReview
      : window.location.href.includes('review');

  const { t } = useTranslation();

  useEffect(() => {
    if (initialSelectState(store) !== selectedOption) {
      setSelectedOption(initialSelectState(store));
    }
  }, [initialSelectState, selectedOption, store, store.customer]);

  useEffect(() => {
  }, [
    dispatch,
    parent,
    showSubFieldError,
    validateContactCardSubFileds,
    t,
    isNewContact
  ]);

  const handleChange = async (value: string) => {
    if (value !== getIn(store.customer, name)) {
      setSelectedOption(value);

      if (onChange) {
        contactDeliveryType(name, dispatch, value);
        await onChange(value, dispatch, formik, store);
      }

      apiService.updateCustomer(store.customer, dispatch);
    }
  };

  const shouldShowChildren =
    selectedOption ===
    options.find(o => o.shouldShowChildren)?.value;

  const errorValidation = () => {
    if (!isNewContact && isReviewPage) {
      return (
        <ErrorValidation>
          <ErrorIcon />
          <p>{t('errors.required')}</p>
        </ErrorValidation>
      );
    }

    if (!validateContactCardSubFileds && isReviewPage) {
      return (
        <ErrorValidation>
          <ErrorIcon />
          <p>{t('errors.requiredContactCard')}</p>
        </ErrorValidation>
      );
    }

    return null;
  };

  return (
    <Container>
      <SelectContainer>
        <SelectDropDown
          name={name}
          useValueProp
          required={required}
          value={selectedOption}
          options={options}
          onChange={handleChange}
          placeholder={t('buttons.selectContactMethod')}
          label={label}
          formik={formik}
          {...otherProps}
        />
      </SelectContainer>

      {shouldShowChildren &&
        mapPageFields(selectChildren, store, formik)}

      <div>{errorValidation()}</div>
    </Container>
  );
};


const FieldSelectWithChildren = withStore(Component);

export default FieldSelectWithChildren;